import { Flex } from "antd";
import { ItemInfo } from "components";
import { COMPANY_TYPE_LABELS, CompanyEntity } from "interfaces";
import { observer } from "mobx-react-lite";
import { getPhone, dateFormat } from "utils";

export const CompanyInfo = observer(({ companyCard }: { companyCard: CompanyEntity }) => {
  return (
    <Flex vertical>
      <ItemInfo title="Тип" text={COMPANY_TYPE_LABELS[companyCard.type]} vertical={false} />
      <ItemInfo title="Название" text={companyCard.companyName} vertical={false} />
      <ItemInfo title="ОГРН" text={companyCard.companyRegistrationNumber} vertical={false} />
      <ItemInfo title="ИНН" text={companyCard.inn} vertical={false} />
      <ItemInfo title="КПП" text={companyCard.kpp} vertical={false} />
      <ItemInfo title="Юридический адрес" text={companyCard.address ?? "-"} vertical={false} />
      <ItemInfo title="Юр. лицо - резидент РФ" text={companyCard.isResident ? "Да" : "Нет"} vertical={false} />
      <ItemInfo
        title="Руководство - резиденты РФ"
        text={companyCard.isControlPersonsRF ? "Да" : "Нет"}
        vertical={false}
      />
      <ItemInfo
        title="Учредители - резиденты РФ"
        text={companyCard.isOnlyTaxResidentRF ? "Да" : "Нет"}
        vertical={false}
      />

      <ItemInfo title="Иностранная организация" text={companyCard.isForeignOrg ? "Да" : "Нет"} vertical={false} />
      <ItemInfo title="Телефон" text={getPhone(companyCard.phone ?? "") || "—"} vertical={false} />
      <ItemInfo title="Email" text={companyCard.email ?? "—"} vertical={false} />
      <ItemInfo
        title="Дата заключения договора"
        text={dateFormat(companyCard.contractDate ?? "") ?? "—"}
        vertical={false}
      />
      <ItemInfo title="Номер договора-основания" text={companyCard.contractNumber ?? "—"} vertical={false} />
    </Flex>
  );
});
